import React, { useState } from 'react';
import styled from 'styled-components';
import { t } from 'ttag';
import { money } from '../../../../../../../services/format';
import { CTA } from '../../../../../../general/Button';
import PageSpinnerThree from '../../../../../../general/PageSpinnerThree';
import useOperatorContext from "../../../../../../../contexts/operator/useOperatorContext";

type AddButtonProps = {
    validated: boolean;
    edit: boolean;
    onClick: () => void;
    total: number;
    disabled?: boolean;
    loading: boolean;
};

const ItemUpdateButton = ({ validated, edit, onClick, total, disabled = false, loading }: AddButtonProps) => {
    const operatorContext = useOperatorContext();

    return (
        <AddButtonWrapper disabled={loading} loading={loading} onClick={onClick}>
            <span>{edit ? t`Edit for` : t`Add for`} {money(total, operatorContext.operator?.ccy, operatorContext.operator?.locale)}</span>
            <StyledSpinnerOverlay show={loading}>
                <PageSpinnerThree show={true}/>
            </StyledSpinnerOverlay>
        </AddButtonWrapper>
    );
};

const StyledSpinnerOverlay = styled.div<{show: boolean}>`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #EBEBEB;
    transition: opacity 0.1s ease-in-out;
    opacity: ${(props) => props.show ? '1' : '0'};
    border-radius: var(--radius_l);
`;

const AddButtonWrapper = styled(CTA)`
    height: 48px;

    @media screen and (min-width: 768px) {
        width: 528px;
    }
`;

export default ItemUpdateButton;
